import React from "react";
import { useRecoilState, useResetRecoilState } from "recoil";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import arrowLeftIcon from "@iconify/icons-mdi/arrow-left";
import { InlineIcon } from "@iconify/react";
import { myTaxSelectedTaxDeclarationState } from "my-tax/states/selected-tax-declaration-state";

const useSelectedTaxDeclaration = () => {
  const [selected, setSelected] = useRecoilState(
    myTaxSelectedTaxDeclarationState,
  );
  const reset = useResetRecoilState(myTaxSelectedTaxDeclarationState);
  return {
    selected,
    setSelected,
    reset,
  };
};

interface MyTaxApplicationHeaderProps {
  title: string;
  onCancel: () => void;
  noWrap?: boolean;
  isMobile?: boolean;
}

const MyTaxApplicationHeader: React.FC<MyTaxApplicationHeaderProps> = ({
  title,
  onCancel,
  noWrap = true,
  isMobile,
}) => {
  const theme = useTheme();

  const { reset } = useSelectedTaxDeclaration();

  const handleBack = () => {
    onCancel();
    reset();
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      padding="16px"
      style={{
        backgroundColor: theme.palette.primary.main,
        height: isMobile ? "auto" : "40px",
        color: "white",
        borderRadius: "8px",
      }}
    >
      <Box
        color={theme.palette.white.main}
        height="24px"
        lineHeight={isMobile ? "0px" : "24px"}
        onClick={handleBack}
        id="btGoBack"
      >
        <InlineIcon
          icon={arrowLeftIcon}
          style={{
            width: "24px",
            height: "24px",
            cursor: "pointer",
            color: theme.palette.white.main,
          }}
        />
      </Box>
      <Box width={isMobile ? "16px" : "40px"} />
      <Box flexGrow={1} textAlign="center" width={isMobile ? "100%" : "400px"}>
        <Typography
          noWrap={isMobile ? false : noWrap}
          variant="h6"
          style={{ color: theme.palette.white.main }}
        >
          {title}
        </Typography>
      </Box>
      <Box width={isMobile ? "16px" : "40px"} />
      {isMobile && <Box width="36px" />}
    </Box>
  );
};

export default MyTaxApplicationHeader;
